import { basicListAddEditDltInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { paymentControllerActionTypes } from '../actions/actionTypes';

const resetServerValue = (state, action) => ({
  ...state,
  serverRequestError: action.data && action.data.serverRequestError,
});

const PaymentController = (state = { ...basicListAddEditDltInitialState }, action = null) => {
  switch (action.type) {
    // Configure Page Details
    case paymentControllerActionTypes.SET_PCM_DETAILS_RESPONSE:
      return {
        ...state,
        subModuledetails: action.data,
      };
    case paymentControllerActionTypes.RESET_SERVER_VALUE:
      return resetServerValue(state, action);
    case commonTypes.RESETSTORE:
      return basicListAddEditDltInitialState;
    default:
      return state;
  }
};

export default PaymentController;
